import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AuthUser } from '@classes/auth/auth-user';
import { AppUser } from '@classes/auth/infosUser';
import { Camera, latlngConvert } from '@classes/camera/camera';
import {
  faInfoCircle,
  faSearch,
  faCar,
  faPlus,
  faVideo,
  faInfo,
  faCogs,
  faPen,
  faRedo,
  faMapMarkedAlt,
} from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';
import { CamerasService } from '@services/cameras/cameras.service';
import { DataService } from '@services/data/data.service';
import { RolesService } from '@services/roles/roles.service';
import { ActionComponent } from 'app/components/admin/action/action.component';
import { CameraOptionComponent } from 'app/components/admin/camera-option/camera-option.component';
import { SmartparkingCameraInfosLastSyncComponent } from 'app/components/smartparking/smartparking-camera-infos-last-sync/smartparking-camera-infos-last-sync.component';
import { SmartparkingCamerasAddComponent } from 'app/components/smartparking/smartparking-cameras-add/smartparking-cameras-add.component';
import { SmartparkingCamerasConfigComponent } from 'app/components/smartparking/smartparking-cameras-config/smartparking-cameras-config.component';
import { UserService } from '@services/user/user.service';

@Component({
  selector: 'app-camera-info-smart-waste',
  templateUrl: './camera-info-smart-waste.component.html',
  styleUrls: ['./camera-info-smart-waste.component.scss'],
})
export class CameraInfoSmartWasteComponent implements OnInit {
  user: AuthUser;
  @Input() cameras: Camera[];

  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faCar = faCar;
  faPlus = faPlus;
  faVideo = faVideo;
  faInfo = faInfo;
  faCogs = faCogs;
  faMarker = faMapMarkedAlt;
  faPen = faPen;
  faRedo = faRedo;
  displayedColumns: string[] = ['name', 'localisation', 'battery'];
  dataSource: MatTableDataSource<Camera>;

  lat = 50.597551;
  lng = 3.403683;
  zoom = 7.8;

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  isAdmin: boolean;
  loading: boolean;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  show = false;
  userAppSelected: AppUser;
  camera: Camera[];

  constructor(
    private dialog: MatDialog,
    private dataService: DataService,
    public router: Router,
    private roleService: RolesService,
    private authService: AuthService,
    private cameraService: CamerasService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.roleService.getRoleUserApp();
    this.userIsAdmin();
    this.getCamera();
    this.getUserCurrent();

    this.userService.clientChangedSubject.subscribe(() => {
      this.loading = true;

      this.getCamera();
      this.loading = false;
    });
  }

  applyFilter(filterValue): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogInfoCamera(camera: Camera): void {
    const dialogRef = this.dialog.open(
      SmartparkingCameraInfosLastSyncComponent,
      {
        data: { camera },
      }
    );
  }

  openDialogAddCamera(): void {
    const dialogRef = this.dialog.open(SmartparkingCamerasAddComponent);

    dialogRef.afterClosed().subscribe(() => {
      this.getCamera();
    });
  }

  openDialogOptionCamera(camera: Camera): void {
    const dialogRef = this.dialog.open(CameraOptionComponent, {
      data: { camera },
    });
  }

  openDialogAction(camera: Camera): void {
    const dialogRef = this.dialog.open(ActionComponent, {
      data: { camera },
      width: '40%',
    });
  }

  openConfigCamera(element: Camera): void {
    const dialogRef = this.dialog.open(SmartparkingCamerasConfigComponent, {
      data: { camera: element },
    });
  }

  showElement(): void {
    setTimeout(() => {
      this.show = true;
    }, 150);
  }

  getUserCurrent() {
    this.user = this.authService.getUser();
  }
  updateMarker(el): void {
    this.lat = el.location.lat;
    this.lng = el.location.lng;
    this.zoom = 15;
  }

  getCameraFiltered(): Camera[] {
    return this.cameras?.filter((c) => c.location);
  }

  private userIsAdmin(): void {
    this.userAppSelected?.roleUser === 'Admin'
      ? this.dataService.isAdmin.next(true)
      : this.dataService.isAdmin.next(false);
  }

  private getCamera(): void {
    this.cameraService.getCameras().subscribe((res) => {
      const test = res.map((r) => r.location);

      const check = [undefined, 'string', '2'];

      res.forEach((el) => {
        if (el.location && !check.includes(el.location as string)) {
          const latLngSplit = (el.location as string)?.split(',');
          el.location = new latlngConvert(+latLngSplit[0], +latLngSplit[1]);
        } else {
          el.location = new latlngConvert(0, 0);
        }
      });

      this.cameras = res;

      this.dataSource = new MatTableDataSource<Camera>(this.cameras);

      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }
}
